import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

function useLoggingService() {
  const { apiClientInstance } = useAPIClientHelper();

  const logError = (message: string, stackTrace: string) => {
    return apiClientInstance(AuthEnums.AuthType.User).LoggingClient.LogError({
      message: message,
      stackTrace: stackTrace,
      clientType: WintSuperkollAPIModel.ClientType.WebClient,
    });
  };
  return {
    logError,
  };
}

export default useLoggingService;
